const StakeLoading = ({ fullpage = false }) => {
  return (
    <div
      className={`${
        fullpage
          ? "fixed inset-0 z-[3] mt-0 flex min-h-auto items-center justify-center bg-[var(--color-surface-default,#1a2c38)]"
          : "flex min-h-[200px] items-center justify-center"
      }`}
    >
      <div className="relative h-2 w-16 rounded-full bg-[var(--stake-loading-bg)] px-0.5 flex items-center">
        <div className="absolute h-1.5 w-4 rounded-full bg-[var(--stake-loading-dot)] shadow-sm animate-[slideLeftRight_0.8s_ease-in-out_infinite]" />
      </div>
    </div>
  );
};

export default StakeLoading;
